/**
 * @param date A date instance. The models contain DateString
 * instances, so see that model for more information.
 * @param now a number generated by the **Date.now();** function.
 */
export const getElapsedSeconds = (date: Date, now: number): number =>
    Math.round((now - date.getTime()) / 1000);
